import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function FetchUserDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/userProfileByUserId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllUsersList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAlluser`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getAllLoginHistoryByUserId(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllLoginHistoryByUserId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getAllLoginHistoryByUser() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllLoginHistoryByUser`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchUserByCompany(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllUserByCompany/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function UserCreate(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/user`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchreportingRoleUsers() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/reportingRoleUsers`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findCompanyRoleUserByReporting(departmentData, company) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findCompanyRoleUserByReporting/${departmentData}/${company}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getByUser(headersData) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByUser`, {
            headers: headersData ?? headers
        });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getByUserProfile(headersData) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/userProfile`, {
            headers: headersData ?? headers
        });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getUserById(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/user/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteUser(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/user/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createUser(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/user`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateUser(payload, drawerId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/user/${drawerId}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateUserProfile(payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateUserProfile`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function resetPassword(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/resetPassword`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    deleteUser,
    createUser,
    updateUser,
    getUserById,
    FetchUserDetails,
    FetchUserByCompany,
    UserCreate,
    FetchAllUsersList,
    FetchreportingRoleUsers,
    getByUser,
    getByUserProfile,
    findCompanyRoleUserByReporting,
    getAllLoginHistoryByUserId,
    updateUserProfile,
    getAllLoginHistoryByUser,
    resetPassword,
}